import { useAdminPendingReportCount, useAdminReportQueue } from './useAdminReports'
import type { EventReport } from '../types'

export function useAdminEventReports() {
  return useAdminReportQueue<EventReport>('eventReports')
}

export function useAdminPendingEventReportCount(): number {
  return useAdminPendingReportCount('eventReports')
}
